/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TLastCommentsModel,
  ILastCommentsRequest,
  IMappers,
  ILastCommentsResponse,
  ILastCommentsResponseError,
  TLastCommentsResponse,
} from './types';

const defaultConfig: TLastCommentsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'journal',
  pathApi: '/v1/last-comments/',
  hostType: 'api',
} as TLastCommentsModel;

function createLastCommentsModel(parameters: ILastCommentsRequest): TLastCommentsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ILastCommentsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ILastCommentsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchLastComments<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ILastCommentsOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TLastCommentsResponse> {
  const { response, statusCode } = await httpApi.fetch(createLastCommentsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ILastCommentsResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ILastCommentsResponseError);
    }
  }

  return { response, statusCode } as TLastCommentsResponse;
}

export { defaultConfig, createLastCommentsModel, fetchLastComments };
